// extracted by mini-css-extract-plugin
export default {"googleMapIframe":"_5r7Rh___EmbeddedMap-module__googleMapIframe","iframeContainer":"MG1QY___EmbeddedMap-module__iframeContainer"};